export const demographyOptions = [
  { value: "age", label: "Age" },
  { value: "gender", label: "Gender" },
  // { value: "community", label: "Community" },
  { value: "ageGender", label: "Age vs Gender" }
  // { value: "ageCommunity", label: "Age vs Community" },
  // { value: "ganderCommunity", label: "Gender vs Community" }
];
